module.exports = __webpack_public_path__ + "img/uploadicon.a39314dc.png";